import { GridApi, IRowNode } from "ag-grid-community";

import { calculateDelta } from "fond/utils/number";

const DIFF_THRESHOLD_PERCENT = 1;
export const SIGNIFICANT_DIFF_PERCENT = 5;
export const SIGNIFICANT_DIFF_ABSOLUTE = 1000;

export interface CellDiff {
  delta: number;
  deltaPercent: number;
  isIncrease: boolean;
  hasDiff: boolean;
  isSignificant: boolean;
}

/**
 * Compares a Total cost cell's own value against the baseline column's value for the same row/group node.
 */
export function getCellDiff(value: number | null | undefined, api: GridApi, node: IRowNode, baselineColId: string): CellDiff | null {
  const baselineValue = api.getCellValue<number>({ rowNode: node, colKey: baselineColId });
  const costDelta = calculateDelta(value, baselineValue);
  if (!costDelta) return null;

  return {
    ...costDelta,
    hasDiff: Math.abs(costDelta.deltaPercent) >= DIFF_THRESHOLD_PERCENT,
    isSignificant: Math.abs(costDelta.deltaPercent) >= SIGNIFICANT_DIFF_PERCENT && Math.abs(costDelta.delta) >= SIGNIFICANT_DIFF_ABSOLUTE,
  };
}
